module.exports = {"information_analysis":"Anàlisi d'informació","select_device":"Slececciona Dispositiu","date_range":"Rang de dates","select_var":"Selecciona Variable","tension":"Tensió","intensity":"Intensitat","cos_phi":"Cosinus Phi","power_factor":"Factor Pot.","active_energy":"Energia Act.","reactive_energy":"Energia React.","max_demand":"Max. Demanda","active_power":"Potencia Act.","harmonic_intensity":"Armonic Int.","harmonic_tension":"Armonic Ten.","graphic":"Gràfic","table":"Taula","info_to_export":"Informació a Exportar","maximeter_historical":"Històric Maxímetre"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/cat/ExportData.json
// module id = 588
// module chunks = 1